import React, { FC } from 'react';

export const RedBackground: FC = () => <div className='size-full bg-srgRed' />;
